<template>
  <div id="app">
    <router-view/>
    <div class="subscribe" :class="{show: subscribeDialog}">
      <div class="mask" @click="closeDialog"></div>
      <div class="wrap">
        <div class="desc">Subscribe to MEW to receive our daily newsletter — all our New collection / Events / New Shops and much more...</div>
        <div class="form">
          <input ref="email" v-model="form.email" type="text" placeholder="Email*" />
          <input ref="name" v-model="form.name" type="text" placeholder="Name*" />
          <select ref="gender" v-model="form.gender">
            <option selected disabled value="">Gender</option>
            <option value="0">Female</option>
            <option value="1">Male</option>
          </select>
          <input ref="country" v-model="form.country" type="text" placeholder="Country" />
          <input ref="city" v-model="form.city" type="text" placeholder="City" />
          <button :disabled="loading" @click="submit">{{loading ? 'loading' : 'Subscribe'}}</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'app',
    data () {
      return {
        loading: false,
        form: {
          email: '',
          name: '',
          gender: '',
          country: '',
          city: ''
        }
      }
    },
    computed: {
      ...mapState([
        'subscribeDialog'
      ])
    },
    async mounted () {
      this.resize()
      window.addEventListener('resize', () => {
        this.resize()
      })

      const data = await this.axios.get('/options')
      this.$store.commit('TOGGLE', {key: 'options', val: data})
      window.document.title = data.title

    },
    methods: {
      async submit () {
        let nullFiled = ''
        for (let key in this.form) {
          const val = this.form[key].trim()
          if (val.length === 0) {
            nullFiled = key
            break
          }
        }

        if (this.form.email.length > 0) {
          if (!/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(this.form.email)) {
            this.$toast(`The email is incorrect`)
            return
          }
        }

        if (nullFiled !== '') {
          this.$toast(`${nullFiled} not be empty`)
          if (this.$refs[`${nullFiled}`].select) {
            this.$refs[`${nullFiled}`].select()
          }
          return
        }

        try {
          this.loading = true
          await this.axios.post('/subscribe', this.form)
          this.$toast(`Submit success`)
        } catch (e) {
          this.$toast(e.response.data.message || '请求出错')
        } finally {
          this.loading = false
        }

      },
      resize () {
        this.$store.commit('TOGGLE', {key: 'width', val: window.innerWidth})
      },
      closeDialog () {
        this.$store.commit('TOGGLE', {
          key: 'subscribeDialog',
          val: false
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .subscribe
    display none
    &.show
      display block
    .mask
      position fixed
      z-index 100
      background-color rgba(255, 255, 255, 0.3)
      left 0
      top 0
      bottom 0
      right 0
    .wrap
      position fixed
      z-index 101
      top 116px
      left 50%
      width 400px
      background-color #fff
      border 2px solid #000
      transform translateX(-50%)
      padding 40px 70px
      .desc
        line-height 1.8
        font-size 12px
      .form
        margin-top 20px
        button
          cursor pointer
          background-color #000
          color #fff
        button
        select
        input
          margin-top 25px
          width 100%
          height 34px
          padding 0 10px
          border 1px solid #000
          border-radius 6px

  @media screen and (max-width: 768px)
    .subscribe
      max-width 100%
      .wrap
        width 90%
</style>
